import * as Yup from 'yup';
import * as GoogleLibPhoneNumber from 'google-libphonenumber';
const phoneUtil = GoogleLibPhoneNumber.PhoneNumberUtil.getInstance();

const phoneNumberValidationES = Yup.object()
  .test(
    'valid-phone-number',
    'El número celular ingresado no es válido.',
    (obj): boolean => {
      // null is not valid
      if (!obj?.number) return false;

      const dialRegex = new RegExp(`^${obj.countryDialCode}(.*)`);
      // null is a valid value, we need to discard the dial in order to see if resultant number is empty
      const numberWithoutDial = (
        dialRegex.exec(obj.number) as Array<string>
      )[1];
      if (!numberWithoutDial) return true;

      try {
        const number = phoneUtil.parse(obj.number, obj.countryCode);
        if (phoneUtil.isValidNumber(number)) {
          return true;
        }
        return false;
      } catch (e) {
        return false;
      }
    }
  )
  .required('El número de celular es un campo requerido.');

const phoneNumberValidationEN = Yup.object()
  .test(
    'valid-phone-number',
    'The entered phone number is not valid.',
    (obj): boolean => {
      // null is not valid
      if (!obj?.number) return false;

      const dialRegex = new RegExp(`^${obj.countryDialCode}(.*)`);
      // null is a valid value, we need to discard the dial in order to see if resultant number is empty
      const numberWithoutDial = (
        dialRegex.exec(obj.number) as Array<string>
      )[1];
      if (!numberWithoutDial) return true;

      try {
        const number = phoneUtil.parse(obj.number, obj.countryCode);
        if (phoneUtil.isValidNumber(number)) {
          return true;
        }
        return false;
      } catch (e) {
        return false;
      }
    }
  )
  .required('Phone number is a required field.');

const invoiceValidationES = Yup.object().shape({
  firstName: Yup.string().required('Nombre es un campo requerido.'),
  lastName: Yup.string().required('Apellido es un campo requerido.'),
  email: Yup.string()
    .email('El email ingresado no es válido.')
    .required('Email es un campo requerido.'),
  idType: Yup.string().required('Tipo de ID es un campo requerido.'),
  idNumber: Yup.number().required(
    'No. de identificación es un campo requerido'
  ),
  address: Yup.string().required('Dirección es un campo requerido.'),
  phoneNumber: phoneNumberValidationES,
});

const invoiceValidationEN = Yup.object().shape({
  firstName: Yup.string().required('First name is a required field.'),
  lastName: Yup.string().required('Last name is a required field.'),
  email: Yup.string()
    .email('The email entered is not valid.')
    .required('Email is a required field.'),
  idType: Yup.string().required('ID type is a required field.'),
  idNumber: Yup.number().required('ID number is a required field.'),
  address: Yup.string().required('Address is a required field.'),
  phoneNumber: phoneNumberValidationEN,
});

export { invoiceValidationES, invoiceValidationEN };
